import { PaymentTermAddHeader } from './PaymentTermAddHeader'
import PaymentTermMainForm from './PaymentTermMainForm'

const PaymentTermForm = () => {
  return (
    <div>
      <PaymentTermAddHeader />
      <PaymentTermMainForm />
    </div>
  )
}

export default PaymentTermForm
